import { GridIcon } from '@radix-ui/react-icons'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel, useKestrelViewerContext } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { SubmenuComponent } from 'features/kestrelViewer/ui/tools/SubmenuComponent'
import React, { FC, useState } from 'react'

import { InspectionGridSettingsButton } from './InspectionGridSettingsButton'

export const ToggleInspectionGridButton: FC = () => {
  const { sendKVCommand, kestrelModel } = useKestrel()
  const { inspectionGridSettings } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const [showInspectionGrid, setShowInspectionGrid] = useState(false)

  const handleClick = () => {
    if (
      !kestrelModel ||
      !inspectionGridSettings ||
      !kestrelModel.data.boundingBox
    ) {
      return
    }

    if (sendKVCommand) {
      const measurementScale =
        (kestrelModel?.data.measurementScale ?? 100) / 100

      const data = showInspectionGrid
        ? {
            command: KestrelCommands.HIDE_INSPECTION_GRID,
          }
        : {
            command: KestrelCommands.SHOW_INSPECTION_GRID,
            center: kestrelModel.data.boundingBox.center,
            corners: kestrelModel.data.boundingBox.corners,
            z: kestrelModel.data.boundingBox.maxZ,
            gridOffset: inspectionGridSettings.gridOffset / measurementScale,
            gridSpacing: inspectionGridSettings.gridSpacing / measurementScale,
            color: inspectionGridSettings.color,
            lineThickness:
              inspectionGridSettings.lineThickness / measurementScale,
            labelVisibility: inspectionGridSettings.labelVisibility,
          }

      sendKVCommand(data)

      setShowInspectionGrid(!showInspectionGrid)
      trackButtonClicked({
        button_name: 'kestrel_show_inspection_grid',
        kestrel_model_id: kestrelModel?.data.kestrel_model_id,
      })
    }
  }

  return (
    <SubmenuComponent
      label={`${showInspectionGrid ? 'Hide' : 'Show'} Rooftop Inspection Grid`}
      icon={<GridIcon width={22} height={22} style={{ color: 'white' }} />}
      handleClick={handleClick}
      selected={showInspectionGrid}>
      <InspectionGridSettingsButton />
    </SubmenuComponent>
  )
}
